export default __webpack_public_path__ + "static/media/webinars.80126192.webp";